import { gql } from './client';
import * as Q from '../graphql/queries';

export const fetchDevices = () => gql(Q.getDevices, {}, 'getDevices').then(d => d || []);
export const fetchDevice = (device_id) => gql(Q.getDevice, { device_id }, 'getDevice');
export const fetchSolaxData = (date) => gql(Q.getSolaxData, { date }, 'getSolaxData').then(d => d || []);
export const fetchForecast = (device_id, date) =>
    gql(Q.getTemperatureForecast, { device_id, date }, 'getTemperatureForecast').then(d => d || []);
export const fetchMeasurements = (device_id, date) =>
    gql(Q.getData, { device_id, date }, 'getData').then(d => d || []);
export const fetchHeatingStatus = (device_id, date) =>
    gql(Q.getHeatingStatus, { device_id, date }, 'getHeatingStatus').then(d => d || []);
export const fetchSolarForecast = (device_id, date) =>
    gql(Q.getSolarForecast, { device_id, date }, 'getSolarForecast').then(d => d || []);
export const fetchHeatingSchedule = (device_id) =>
    gql(Q.getHeatingSchedule, { device_id }, 'getHeatingSchedule').then(d => d || []);

export const putDeviceMetadata = (vars) => gql(Q.putDeviceMetadata, vars, 'putDeviceMetadata');
export const putHeatingEvent = (vars) => gql(Q.putHeatingEvent, vars, 'putHeatingEvent');
export const deleteHeatingEvent = (device_id, event_id) =>
    gql(Q.deleteHeatingEvent, { device_id, event_id }, 'deleteHeatingEvent');
export const solveSchedule = (device_id) => gql(Q.solveSchedule, { device_id }, 'solveSchedule');
export const fetchMySites = () => gql(Q.getMySites, {}, 'getMySites').then(d => d || []);
